(function () {
    'use strict';

    angular
        .module('app')
        .controller('CacsController', CacsController);

    CacsController.$inject = ['API', 'helpers', '$stateParams', '$q', 'i18n', '$state', '$scope', 'alert', '$http',];

    function CacsController(API, helpers, $stateParams, $q, i18n, $state, $scope, alert, $http) {
        var vm = this;

        vm.now = helpers.getDatabaseDatetime();

        vm.loadingState = {
            cac: false,
        };
        vm.isSaving = false;
        vm.isInvalidResult = false;
        vm.years = [];

        vm.fields = ['b2c', 'b2b', 'clm', 'facebook', 'google', 'apple', 'staff', 'influencer_marketing_med_byrå', 'influencer_marketing_internt', 'konverteringsbyrå', 'clv', 'sum', 'trials', 'conversionRate', 'cac', 'staff_fte', 'staff_hourly_cost'];
        vm.summableFields = ['facebook', 'google', 'apple', 'influencer_marketing_med_byrå', 'influencer_marketing_internt', 'konverteringsbyrå', 'staff'];

        vm.removeExtraField = removeExtraField;
        vm.addExtraField = addExtraField;
        vm.calculate = calculate;
        vm.save = save;
        vm.loadCacHistory = loadCacHistory;
        vm.onDateChange = onDateChange;
        vm.openRemoveExtraFieldModal = openRemoveExtraFieldModal;
        vm.calculateStaffCosts = calculateStaffCosts;
        vm.facebookManagerLink = '';

        activate();

        function activate() {
            resetFields();
            var today = new Date();
            var thisYear = String(today.getFullYear());
            var paddedMonth = today.getMonth() + 1 < 10 ? '0' : '';
            for (var index = 0; index < 20; index++) {
                vm.years.push(String(thisYear - index));
            }

            vm.month = $stateParams.month || paddedMonth + (today.getMonth() + 1);
            vm.year = $stateParams.year || String(today.getFullYear());

            $scope.$watch('vm.year', function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    loadCacHistory();
                }
            });
            $scope.$watch('vm.month', function(newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    loadCacHistory();
                }
            });

            var lastMonth = parseInt(vm.month, 10) - 1;
            vm.lastYear = vm.year;
            if (lastMonth < 1) {
                vm.lastMonth = '12';
                vm.lastYear = String(parseInt(vm.lastYear, 10) - 1);
            } else if (lastMonth < 10) {
                vm.lastMonth = '0' + lastMonth;
            } else {
                vm.lastMonth = String(lastMonth);
            }

            vm.facebookManagerLink = 'https://www.facebook.com/adsmanager/manage/all?act=253665101492154&columns=name%2Cerrors%2Cdelivery%2Ccampaign_name%2Cbid%2Cbudget%2Clast_significant_edit%2Cresults%2Creach%2Cimpressions%2Ccost_per_result%2Cquality_score_organic%2Cquality_score_ectr%2Cquality_score_ecvr%2Cspend%2Cend_time%2Cschedule%2Cactions%3Alink_click%2Cactions%3Aoffsite_conversion.fb_pixel_purchase&attribution_windows=default&date=' + vm.lastYear + '-' + vm.lastMonth + '-01_' + vm.year + '-' + vm.month + '-01%2Clast_month&comparison_date=';
            vm.googleManagerLink = 'https://ads.google.com/aw/overview?ocid=197784935&__c=2794584815&authuser=0&__u=7742327189';
            vm.appleManagerLink = 'https://idmsa.apple.com/IDMSWebAuth/signin?appIdKey=a01459d797984726ee0914a7097e53fad42b70e1f08d09294d14523a1d4f61e1&rv=1&path=';

            loadCacHistory();
            loadB2cProfit();
        }

        function addExtraField() {
            var extraField = new API.CacHistory({
                year: vm.year,
                month: vm.month,
                key: '',
                value: '0',
            });
            vm.extraFields.push(extraField);
        }

        function calculate() {
            var sum = parseInt(vm.facebook.value, 10) + parseInt(vm.google.value, 10) + parseInt(vm.influencer_marketing_med_byrå.value, 10) + parseInt(vm.influencer_marketing_internt.value, 10) + parseInt(vm.konverteringsbyrå.value, 10) + +parseInt(vm.apple.value, 10) + parseInt(vm.staff.value, 10);
            angular.forEach(vm.extraFields, function(extraField) {
                sum += parseInt(extraField.value, 10) || 0;
            });

            vm.sum.value = String(sum);

            if (!(parseInt(vm.sum.value, 10) === 0 || parseInt(vm.trials.value, 10) === 0 || parseFloat(vm.conversionRate.value) === 0)) {
                var cac = parseInt(vm.sum.value, 10) / parseInt(vm.trials.value, 10) / parseFloat(vm.conversionRate.value);
                vm.cac.value = String(Math.round(cac * 100) / 100);
            }
            vm.isInvalidResult = isNaN(parseInt(vm.cac.value, 10)) || parseInt(vm.cac.value, 10) === Infinity;
        }

        function calculateStaffCosts() {
            var sum = parseFloat(vm.staff_fte.value, 10) * 160 * parseInt(vm.staff_hourly_cost.value, 10);
            vm.staff.value = String(sum);
            calculate();
        }

        function deleteExtraFieldFromDatabase(cacHistoryObject) {
            var promise = cacHistoryObject.$delete();

            promise.then(function() {
                window.toast({ message: i18n.get('EXTRA_FIELD_REMOVED_FROM_DATABASE'), type: 'success' });
            }, function() {});
        }

        function loadConversionRatesForMonth() {
            if (parseFloat(vm.conversionRate.value) === 0) {
                var promise = API.Statistic.conversionRatesForMonth({
                    month: vm.month,
                    year: vm.year,
                 }).$promise;

                promise.then(function(response) {
                    vm.conversionRate.value = String(response.total);
                }, function() {});
            }
        }

        function loadB2cProfit() {
            var promise = $http.get('https://integration1.zcooly.se/kpi/report.php?id=result_monthly_total&f=jsond', {
                dataType: 'json',
                headers: {
                    'Content-type': 'application/json; charset=utf-8',
                }
            });
            promise.then(function(response) {
                if (response.data.length && response.status === 200) {
                    angular.forEach(response.data, function(item) {
                        if (item.Month === vm.year + '-' + vm.month) {
                            vm.b2c.value = item['Revenue (SEK)'];
                        }
                    });
                }
            }, function() {});
        }

        function loadCacHistory() {
            vm.loadingState.cac = true;
            resetFields();
            var promise = API.CacHistory.search({
                month: vm.month,
                year: vm.year,
                'per-page': 100
            }).$promise;
            promise.then(function (response) {
                angular.forEach(response.items, function(item) {
                    if (vm.fields.includes(item.key)) {
                        vm[item.key] = new API.CacHistory(item);
                    } else {
                        vm.extraFields.push(new API.CacHistory(item));
                    }
                });
                calculate();
                loadConversionRatesForMonth();
                loadTrialsForMonth();
                loadCustomerLifetimeValueForMonth();
            }, function () {
            })
            .finally(function() {
                vm.loadingState.cac = false;
            });
        }

        function loadCustomerLifetimeValueForMonth() {
            if (parseInt(vm.clv.value, 10) === 0) {
                var promise = API.Statistic.customerLifetimeValueForMonth({
                    month: vm.month,
                    year: vm.year,
                 }).$promise;

                promise.then(function(response) {
                    vm.clv.value = String(response.total);
                }, function() {})
                .finally(function() {
                    calculate();
                });
            }
        }

        function loadTrialsForMonth() {
            if (parseInt(vm.trials.value, 10) === 0) {
                var promise = API.Statistic.trialsForMonth({
                    month: vm.month,
                    year: vm.year,
                 }).$promise;

                promise.then(function(response) {
                    vm.trials.value = String(response.total);
                }, function() {})
                .finally(function() {
                    calculate();
                });
            }
        }

        function onDateChange() {
            $state.go('.', {
                year: vm.year,
                month: vm.month,
            });
        }

        function openRemoveExtraFieldModal(extraFieldId) {
            if (vm.extraFields[extraFieldId].id) {
                var promise = alert.confirm('remove-cac-extra-field');

                promise.then(function() {
                    deleteExtraFieldFromDatabase(vm.extraFields[extraFieldId]);
                    removeExtraField(extraFieldId);
                }, function() {});

            } else {
                removeExtraField(extraFieldId);
            }
        }

        function resetFields() {
            vm.extraFields = [];
            angular.forEach(vm.fields, function(field) {
                vm[field] = new API.CacHistory({
                    value: '0',
                    key: field
                });
            });
            vm.staff_hourly_cost.value = '250';
        }

        function save() {
            vm.isSaving = true;
            var savePromises = [];

            angular.forEach(vm.fields, function(field) {
                vm[field].year = vm.year;
                vm[field].month = vm.month;

                savePromises.push(vm[field].$save());
            });

            angular.forEach(vm.extraFields, function(extraField) {
                savePromises.push(extraField.$save());
            });

            $q.all(savePromises).then(function() {
                window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
            },function () {})
            .finally(function() {
                vm.isSaving = false;
            });
        }

        function removeExtraField(index) {
            vm.extraFields.splice(index, 1);
            calculate();
        }
    }
})();